import React from 'react';
import ErrorMessages from "components/general/ErrorMessages"
import * as FormFields from "components/forms/FormFields"
import { IconButton } from 'components/general/IconButton'
import * as Icons from 'react-bootstrap-icons';

import * as ProfileActions from "actions/ProfileActions"


export default class Education extends React.Component {

	constructor(props) {
		super();
		this.state = {educations: props.profile.educations, editId: null, add: {}, showAdd: false, errors: null}
	}

	componentWillReceiveProps(nextProps, nextState){
		this.setState({educations: nextProps.profile.educations});
	}

	handleChange(event, education) {

		education[event.target.name] = event.target.value;
		var index = -1;
		var educations = this.state.educations;
		educations.forEach(function(value, i) {
		    if (value.id === education.id) {
		    	index = i;
		    }
		});

		if (index >= 0) {
			educations[index] = education;
			this.setState({educations: educations});
		}

	}

	handleSubmit(event, education) {
		this.setState({errors: null});
		ProfileActions.educationUpdate(this.props.accountId, this.props.profile.id, education,
			(profile) => {
				this.unedit();
				this.props.onUpdated(profile);
			},
			(errors) => this.setState({errors: errors})
		);
	}

	handleAddChange(event) {
		var add = this.state.add;
		add[event.target.name] = event.target.value;
		this.setState({add: add});
	}

	handleAddSubmit(event) {
		ProfileActions.educationAdd(this.props.accountId, this.props.profile.id, this.state.add,
			(profile) => {
				this.setState({add: {}, showAdd: false, editId: null, errors: null});
				this.props.onUpdated(profile);
			},
			(errors) => this.setState({errors: errors})
		);
	}

	edit(id) {
		this.setState({editId: id});
	}

	unedit() {
		this.setState({editId: null});
	}

	add() {
		this.setState({add: {}, showAdd: true});
	}

	unadd() {
		this.setState({add: {}, showAdd: false});
	}

	delete(education) {
		if (window.confirm('Delete Education?')) {
			ProfileActions.educationDelete(this.props.accountId, this.props.profile.id, education.id, 
				(profile) => this.props.onUpdated(profile),
				() => alert("Error deleting education")
			);
		}
	}

	renderEducation() {

		return this.state.educations.map((education) => {

			return (
				<li className="education" key={"education" + education.id} >
					<h3>{education.title}</h3>
					<div>{education.organisation}{education.endDate && education.organisation ? ", " : ""}{education.endDate}</div>
					<div className="controls">
						<IconButton icon={<Icons.Trash />} className="small delete-link" onClick={(e) => this.delete(education)}/>
						<IconButton name={<Icons.Pencil />} className="small edit-link" onClick={(e) => this.edit(education.id)}/>
					</div>
					{this.renderEdit(education)}
				</li>
			);

		});

	}

	renderEdit(education) {

		return (
			<FormFields.Model isOpen={this.state.editId && this.state.editId !== "education" && this.state.editId === education.id} onHide={(e) => this.unedit()}
				onCancel={(e) => this.unedit()} onConfirm={(e) => this.handleSubmit(e, education)}>

				<FormFields.Text name="organisation" title="Organisation" placeholder="Name of education provider" value={education.organisation} onChange={(e) => this.handleChange(e, education)} />

				<FormFields.Text name="title" title="Title" placeholder="Title of the degree, certificate or qualification" value={education.title} mandatory={true} onChange={(e) => this.handleChange(e, education)} />

				<div className="row">
					<div className="col">
						<FormFields.DateYear name="startDate" title="From Year" value={education.startDate} onChange={(e) => this.handleChange(e, education)} />
					</div>
					<div className="col">
						<FormFields.DateYear name="endDate" title="To Year" value={education.endDate} mandatory={false} onChange={(e) => this.handleChange(e, education)} />
					</div>
				</div>

			</FormFields.Model>

		);

	}

	renderAdd() {
		return (

			<FormFields.Model isOpen={this.state.showAdd} onHide={(e) => this.unadd()}
				onCancel={(e) => this.unadd()} onConfirm={(e) => this.handleAddSubmit(e)}>

				<FormFields.Text name="organisation" title="Organisation" placeholder="Organisation" value={this.state.add.organisation} onChange={(e) => this.handleAddChange(e)} />

				<FormFields.Text name="title" title="Title" placeholder="Title" mandatory={true} value={this.state.add.title} onChange={(e) => this.handleAddChange(e)} />

				<div className="row">
					<div className="col">
						<FormFields.DateYear name="startDate" title="Start Date" value={this.state.add.startDate ? this.state.add.startDate : null} onChange={(e) => this.handleAddChange(e)} />
					</div>
					<div className="col">
						<FormFields.DateYear name="endDate" title="End Date" value={this.state.add.endDate ? this.state.add.endDate : null} onChange={(e) => this.handleAddChange(e)} />
					</div>
				</div>

			</FormFields.Model>

		);
	}

	render() {
		return (
			<div className="profile-tile">
				<ErrorMessages errors={this.state.errors} component={this}/>

				<h2>Education</h2>
				<div className="controls"><IconButton icon={<Icons.PlusLg />} onClick={(e) => this.add()} /></div>

				<ul className="educations">{this.renderEducation()}</ul>

				{this.renderAdd()}

			</div>
		);
	}

}